import {
  useListOrganizations,
  useListPayors,
  useListSites,
} from 'api/resource';

export const useAdminSiteManagementData = () => {
  const sitesResult = useListSites({ isAdmin: true });
  const payorsResult = useListPayors();
  const organizationResult = useListOrganizations({
    isAdmin: true,
    organizationID: '',
  });

  const isLoading =
    sitesResult.isLoading ||
    payorsResult.isLoading ||
    organizationResult.isLoading;
  const isFetching =
    sitesResult.isFetching ||
    payorsResult.isFetching ||
    organizationResult.isFetching;
  const isError =
    sitesResult.isError || payorsResult.isError || organizationResult.isError;
  const errorMessage =
    sitesResult.error?.message ||
    payorsResult.error?.message ||
    organizationResult.error?.message;

  return {
    sites: sitesResult.data || [],
    payors: payorsResult.data || [],
    organizations: organizationResult.data || [],
    isLoading,
    isError,
    isFetching,
    errorMessage,
  };
};
